import React, { FC } from 'react';

// Delete clsx

export const Typography = (props: any) => {
  const Component = 'p' as keyof JSX.IntrinsicElements;

  return <Component {...props} />;
};
